/**
 * Bind all methods in a class so that nested method calls work as you'd expect
 * @link [explanation](https://stackoverflow.com/questions/56503531/what-is-a-good-way-to-automatically-bind-js-class-methods)
 */
export function classBindThis(_this: any): void {
  Object.getOwnPropertyNames(Object.getPrototypeOf(_this))
    .filter((m) => m !== "constructor")
    .forEach((method) => {
      _this[method] = _this[method].bind(_this)
    })
}

/**
 * shim of Promise.allSettled for native
 */
export function allSettled<T>(values: Promise<T>[]): Promise<PromiseSettledResult<T>[]> {
  return Promise.all(
    values.map((p) =>
      p
        .then((r) => ({status: "fulfilled" as const, value: r}))
        .catch((e) => ({
          status: "rejected" as const,
          reason: e
        }))
    )
  )
}
